var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasChild)?_c('div',{staticClass:"mg-space-item",class:{ 'mg-space-item__empty': _vm.isNoChildren, 'is-vertical': _vm.isVertical },style:(_vm.style)},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }